// eslint-disable-next-line
import { UserLayout, BasicLayout, RouteView, BlankLayout, PageView } from '@/layouts'

/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
  {
    path: '/user',
    component: UserLayout,
    redirect: '/teacher/user/login',

    children: [
      {
        path: 'login',
        name: 'login',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/Login')
      }
    ]
  },
  {
    path: '/',
    name: 'index',
    component: BasicLayout,
    meta: { title: '泡芙教育' },
    redirect: '/dashboard',
    children: [
      // 首页
      {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import('@/views/dashboard/Index'),
        meta: { title: '首页', icon: 'desktop', hiddenPageTitle: true, keepAlive: true }
      },
      // 约课管理
      {
        path: '/subscribe',
        name: 'subscribe',
        component: PageView,
        meta: { title: '约课管理', icon: 'solution', permission: ['form'] },
        redirect: '/subscribe/feijiaokouyulist',
        hideChildrenInMenu: false,
        children: [
          // {
          //   path: '/subscribe/feijiaokouyulist',
          //   name: 'feijiaokouyulist',
          //   component: () => import('@/views/subscribe/feijiaokouyulist'),
          //   meta: { title: '菲教口语预约', keepAlive: true, permission: ['user'] }
          // },
          // {
          //   path: '/subscribe/oumeikouyulist',
          //   name: 'oumeikouyulist',
          //   component: () => import('@/views/subscribe/oumeikouyulist'),
          //   meta: { title: '欧美口语预约', keepAlive: true, permission: ['user'] }
          // },
          {
            path: '/subscribe/kouyulist',
            name: 'kouyulist',
            component: () => import('@/views/subscribe/kouyulist'),
            meta: { title: '口语预约', keepAlive: true, permission: ['user'] }
          },
          {
            path: '/subscribe/zuowenlist',
            name: 'zuowenlist',
            component: () => import('@/views/subscribe/zuowenlist'),
            meta: { title: '作业批改预约', keepAlive: true, permission: ['user'] }
          }
        ]
      },
      // 默认计划及教程
      {
        path: '/plan',
        name: 'plan',
        component: PageView,
        meta: { title: '我的排课', icon: 'solution', permission: ['form'] },
        redirect: '/plan/feijiaoplan',
        hideChildrenInMenu: false,
        children: [
          {
            path: '/plan/feijiaoplan',
            name: 'feijiaoplan',
            component: () => import('@/views/plan/feijiaoplan'),
            meta: { title: '菲教口语排课计划', keepAlive: true, permission: ['user'] }
          },
          {
            path: '/plan/oumeiplan',
            name: 'oumeiplan',
            component: () => import('@/views/plan/oumeiplan'),
            meta: { title: '欧美口语排课计划', keepAlive: true, permission: ['user'] }
          },
          {
            path: '/plan/zuowenplan',
            name: 'zuowenplan',
            component: () => import('@/views/plan/zuowenplan'),
            meta: { title: '作文批改排课计划', keepAlive: true, permission: ['user'] }
          }
        ]
      },
      // 账单
      {
        path: '/bill',
        name: 'bill',
        component: () => import('@/views/bill/Index'),
        meta: { title: '我的账单', icon: 'money-collect', hiddenPageTitle: true, keepAlive: true }
      },
      // 系统设置
      {
        path: '/system',
        name: 'system',
        // component: () => import('@/views/system/Index'),
        component: PageView,
        meta: { title: '系统管理', icon: 'setting', permission: ['form'] },
        redirect: '/system/base',
        hideChildrenInMenu: false,
        children: [
          // {
          //   path: '/system/my',
          //   name: 'my',
          //   component: () => import('@/views/account/center/Index'),
          //   meta: { title: '个人中心', keepAlive: true, permission: ['user'] }
          // },
          {
            path: '/system/base',
            name: 'base',
            component: () => import('@/views/system/base/Setting'),
            meta: { title: '个人中心', keepAlive: true, permission: ['user'] },
            redirect: '/system/base/system',
            hideChildrenInMenu: true,
            children: [
              {
                path: '/system/base/system',
                name: 'System',
                component: () => import('@/views/system/base/System'),
                meta: { title: '个人资料', keepAlive: true, permission: ['user'] }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: '/404',
    component: () => import(/* webpackChunkName: "fail" */ '@/views/exception/404')
  },
  {
    path: '*',
    redirect: '/404',
    hidden: true
  }
]
